/*
* Created on Nov 02, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect} from 'react';
import {useAuthService} from "../hook/AuthServiceHook";

const ReceiveAuthComponent = ({query}) => {
    const query_params = (() => {
        let params = {}
        if (query) {
            for (const [key, value] of query.entries()) {
                if (key === 'state') {
                    const searchParams = new URLSearchParams(value);
                    params['state'] = searchParams.get('state');
                }
                else {
                    params[`${key}`] = value
                }
            }
        }

        return params
    })()
    const {AUTHAPI} = useAuthService();

    const do_auth = async () => {
        const res = await AUTHAPI.do_receive_auth(query_params);
        if (res.result.access_token) {
            sessionStorage.setItem('access_token', res.result.access_token);
        }
        window.location.href = res.result.url;
    }

    useEffect(()=>{
        do_auth();
    })

    return (
        <div />
    );
};

export default ReceiveAuthComponent;